import { render, staticRenderFns } from "./OngoingConsultationCard.vue?vue&type=template&id=eeb51e92&scoped=true&"
import script from "./OngoingConsultationCard.vue?vue&type=script&lang=js&"
export * from "./OngoingConsultationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb51e92",
  null
  
)

export default component.exports